<template>
    <div>
        <ui-autocomplete
            :filter="filterItem"
            :label="label"
            :placeholder="placeholder"
            :suggestions="options"
            :invalid="invalid"
            :error="error"
            :disabled="disabled"
            v-model="internalTextValue"
            @input="updateSuggestions"
            @select="selected"
            :keys="{ label: 'primary_display_as', value: 'primary_display_as' }"
        >
            <div slot="suggestion" slot-scope="scope">
                <span>{{ scope.suggestion.primary_display_as }}</span>
                <span v-if="queryMode === 'email'" style="color: #666;"><{{ scope.suggestion.email }}></span>
                <span v-else-if="queryMode === 'phone' && scope.suggestion.primary_telephone" style="color: #666;"><{{ scope.suggestion.primary_telephone }}></span>
            </div>
        </ui-autocomplete>
    </div>
</template>

<script>
    import SearchesContacts from "../forms/controls/SearchesContacts";
    import { ContactSchema, ContactTypes } from "../../classes/Api/Contact";

    export default {
        mixins: [SearchesContacts],
        props: {
            value: {},
            label: {
                type: String,
                default: 'To'
            },
            placeholder: {
                type: String,
            },
            invalid: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            error: {
                type: String,
            },
            queryMode: {
                type: String,
                default: 'email'
            }
        },
        data() {
            return {
                internalValue: {},
                internalTextValue: '',
            }
        },
        watch: {
            value: {
                handler(n, o) {
                    if (n !== o) {
                        this.selected(n)
                    }
                },
                deep: true,
            }
        },
        mounted() {
            this.selected(this.value)
        },
        methods: {
            selected(s) {
                this.internalValue = s
                this.internalTextValue = s.primary_display_as
                this.updated()
            },
            clear() {
                this.internalTextValue = ''
                this.createNewSchema()
                this.updated()
            },
            updated() {
                if (this.internalValue && !this.internalValue.id && this.internalTextValue) {
                    let parts = this.internalTextValue.split(" ");
                    let firstName = parts[0]
                    let lastName

                    if (parts[1]) {
                        lastName = parts[1]
                    }

                    this.internalValue.first_name = firstName
                    this.internalValue.last_name = lastName
                    this.internalValue.primary_display_as = this.internalTextValue
                }

                this.$emit('input', this.internalValue)
            },
            updateSuggestions(e) {
                if (e === '') {
                    this.clear()
                }

                this.onQueryChange(e)
                this.updated()
            },
            filterItem(s, q, d) {
                // We depend on the server side filtering
                return true
            },
            createNewSchema() {
                this.$set(this, 'internalValue', new ContactSchema({
                    type: ContactTypes.LEAD
                }))

                this.updated();
            }
        }
    }
</script>

<style scoped>

</style>